import theme from "../../themes/themes";
import { createStyles, makeStyles } from "@material-ui/core";

const styles = makeStyles(() =>
	createStyles({
		appBar: {
			transition: theme.transitions.create(["margin", "width"], {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			}),
			color: "#000",
			backgroundColor: "#fff",
			borderBottom: `5px solid ${theme.palette.primary.main}`,
			boxShadow: "none",
		},
		menuButton: {
			marginRight: theme.spacing(2),
		},
		appBarHeader: {
			flex: 1,
		},
		logo: {
			height: "60px",
		},
	})
);
export default styles;
